module.exports = __webpack_public_path__ + "static/media/hoja-con-ganchos.496f77e5.png";